import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegistrationActivityDatasource } from '../../views/registration_transactions/datasources/registration_activity_datasource';
import { IRegistrationActivity } from '../../interfaces/scheduler_interfaces';
import { RegistrationActivityErrorTextStrategy } from '../strategies/registration_activity_text_strategy';

interface IErrorDetail {
  id: number;
  errorTitle: string;
  message: string;
}

export class RegistrationErrorsQuery implements IQuery {
  private _result: {
    errorMessage: string;
    hasErrorMessages: boolean;
    errorDetails: IErrorDetail[];
  };

  constructor(
    private QueryMediator: IQueryMediator,
    private ngRegistrationActivityDatasource: IRegistrationActivityDatasource
  ) {
    this._result = {
      errorMessage: '',
      hasErrorMessages: false,
      errorDetails: []
    };
    QueryMediator.registerQuery(this, ngRegistrationActivityDatasource);
  }

  _getAppendText(action: string): string {
    const appendText = _4.get(RegistrationActivityErrorTextStrategy[_4.toUpper(action)], 'text', '');
    return appendText;
  }

  _getSectionTitle(errDetails: IRegistrationActivity): string {
    const sectionName = _4.get(errDetails, 'context.section_name', '');
    const sectionType = _4.get(errDetails, 'context.section_type', '');
    if (_4.isEmpty(sectionType)) {
      return sectionName;
    }
    return `${sectionName} - ${sectionType}`;
  }

  run() {
    const errors = _4.filter(this.ngRegistrationActivityDatasource.values(), {
      alert_type: 'failure',
      is_active: true
    });
    const errorMessagesCount = _4.size(errors);
    const hasErrorMessages = _4.gt(errorMessagesCount, 0);
    const errorMessage = `${errorMessagesCount} ${
      errorMessagesCount > 1 ? 'requests' : 'request'
    } could not be completed`;

    const errorDetails = _4.orderBy(
      _4.map(errors, (errDetails: IRegistrationActivity) => {
        const { message, alert_type, id } = errDetails;
        const action = _4.get(errDetails, 'context.action', '');
        const errorTitle = `${this._getSectionTitle(errDetails)} ${this._getAppendText(action)}`;
        return {
          errorTitle,
          message,
          id,
          alert_type,
          action,
          time: moment(errDetails.created_ts).format('MMM DD, YYYY LT'),
          timeStamp: moment(errDetails.created_ts).valueOf()
        };
      }),
      ['timeStamp'],
      ['desc']
    );
    this._result = {
      errorMessage,
      hasErrorMessages,
      errorDetails
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationErrorsQuery', RegistrationErrorsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_errors/queries/registration_errors_query.ts